var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',{class:['text-center', _vm.wrapperClass]},[_c('img',{class:['w-full max-w-full', _vm.imageClass],attrs:{"src":_vm.src,"alt":_vm.alt}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }